import React from 'react';

const Input = ({ 
  label, 
  type = 'text', 
  name,
  value, 
  onChange, 
  placeholder,
  error,
  required = false,
  disabled = false,
  icon = null
}) => {
  return (
    <div className="input-group">
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        {icon && <span className="input-icon">{icon}</span>}
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`input ${error ? 'input-error' : ''} ${icon ? 'input-with-icon' : ''}`}
        />
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default Input;